<template>
  <transition v-if="showModal" name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <div class="modal-buttons">
              <!-- <a class="btn-close" @click="closeModal" >X</a> -->
              <a class="close" @click="closeModal"></a>
            </div>
            <div class="header-content">
              <h3>
                {{ translationHelper.getTranslation("wbk_RelationPopupTitle") }}
              </h3>
              <div class="wb-grid-container">
                <div class="wb-grid-item">
                  <course-item
                    :translationHelper="translationHelper"
                    :course="selectedCourse"
                    @bookmark="courseBookmarkChanged"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="wbk-modal-body">
            <div
              v-if="
                selectedCourse.details.parents &&
                selectedCourse.details.parents.length
              "
            >
              <h3
                v-if="selectedCourse.details.parents.length"
                class="details-header"
              >
                {{
                  translationHelper.getTranslation(
                    "wbk_RelationTilteIsPartOfWB"
                  )
                }}
              </h3>
              <div
                v-if="selectedCourse.details.parents.length"
                class="wb-grid-container"
              >
                <div
                  v-for="pCourse in selectedCourse.details.parents"
                  :key="pCourse.id"
                  class="wb-grid-item"
                >
                  <course-item
                    :translationHelper="translationHelper"
                    @click="selectCourse"
                    :course="pCourse"
                    @bookmark="courseBookmarkChanged"
                  />
                </div>
              </div>
            </div>
            <div
              v-if="
                selectedCourse.details.compulsoryModules &&
                selectedCourse.details.compulsoryModules.length
              "
            >
              <h3
                v-if="selectedCourse.details.compulsoryModules.length"
                class="details-header"
              >
                {{
                  translationHelper.getTranslation(
                    "wbk_RelationTitleCompulsoryModules"
                  )
                }}
              </h3>
              <div
                v-if="selectedCourse.details.compulsoryModules.length"
                class="wb-grid-container"
              >
                <div
                  v-for="cCourse in selectedCourse.details.compulsoryModules"
                  :key="cCourse.id"
                  class="wb-grid-item"
                >
                  <course-item
                    :translationHelper="translationHelper"
                    @click="selectCourse"
                    :course="cCourse"
                    @bookmark="courseBookmarkChanged"
                  />
                </div>
              </div>
            </div>
            <div
              v-if="
                selectedCourse.details.electiveCompulsoryModules &&
                selectedCourse.details.electiveCompulsoryModules.length
              "
            >
              <h3
                v-if="selectedCourse.details.electiveCompulsoryModules.length"
                class="details-header"
              >
                {{
                  translationHelper.getTranslation(
                    "wbk_RelationTitleCompulsoryElectiveModules"
                  )
                }}
              </h3>
              <div
                v-if="selectedCourse.details.electiveCompulsoryModules.length"
                class="wb-grid-container"
              >
                <div
                  v-for="ecCourse in selectedCourse.details
                    .electiveCompulsoryModules"
                  :key="ecCourse.id"
                  class="wb-grid-item"
                >
                  <course-item
                    :translationHelper="translationHelper"
                    @click="selectCourse"
                    :course="ecCourse"
                    @bookmark="courseBookmarkChanged"
                  />
                </div>
              </div>
            </div>
            <div
              v-if="
                selectedCourse.details.electiveModules &&
                selectedCourse.details.electiveModules.length
              "
            >
              <h3
                v-if="selectedCourse.details.electiveModules.length"
                class="details-header"
              >
                {{
                  translationHelper.getTranslation(
                    "wbk_RelationTitleElectiveModules"
                  )
                }}
              </h3>
              <div
                v-if="selectedCourse.details.electiveModules.length"
                class="wb-grid-container"
              >
                <div
                  v-for="emCourse in selectedCourse.details.electiveModules"
                  :key="emCourse.id"
                  class="wb-grid-item"
                >
                  <course-item
                    :translationHelper="translationHelper"
                    @click="selectCourse"
                    :course="emCourse"
                    @bookmark="courseBookmarkChanged"
                  />
                </div>
              </div>
            </div>
            <div
              v-if="
                selectedCourse.details.similars &&
                selectedCourse.details.similars.length
              "
            >
              <h3
                v-if="selectedCourse.details.similars.length"
                class="details-header"
              >
                {{
                  translationHelper.getTranslation(
                    "wbk_RelationTitleSimilarCourses"
                  )
                }}
              </h3>
              <div
                v-if="selectedCourse.details.similars.length"
                class="wb-grid-container"
              >
                <div
                  v-for="aCourse in selectedCourse.details.similars"
                  :key="aCourse.id"
                  class="wb-grid-item"
                >
                  <course-item
                    :translationHelper="translationHelper"
                    @click="selectCourse"
                    :course="aCourse"
                    @bookmark="courseBookmarkChanged"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import CourseItem from './CourseItem.vue';
export default {
  components: {
    CourseItem: () => import("./CourseItem.vue")
  },
  props: {
    showModal: {
      type: Boolean,
      default: true,
      required: true,
    },
    selectedCourse: {
      type: Object,
    },
    translationHelper: {
      type: Object,
    },
  },
  methods: {
    closeModal() {
      this.$emit("close-window");
    },
    courseBookmarkChanged(course) {
      this.$emit("bookmark", course);
    },
    selectCourse(course) {
      this.$emit("selectCourse", course);
    },
  },
};
</script>
